export default __webpack_public_path__ + "static/media/KhuuTuanGrid.ca7b60b4.png";